export default "__VITE_PUBLIC_ASSET__1695be68__"